import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="py-20 relative bg-pistachio-50 border-y border-line" data-id="element-101" data-mp="20mef3exz8k06">
      <div className="container mx-auto px-4" data-id="element-102" data-mp="24myhoy1bkftp">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="max-w-3xl mx-auto text-center p-10 md:p-16 rounded-3xl bg-surface border border-line" data-id="element-103" data-mp="24l3t99qua5kv">
          <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-pistachio-100 text-pistachio-700 mb-8 border border-pistachio-200" data-id="element-104" data-mp="2jatbkhr2cq8d">
            <ShieldCheckIcon size={40} aria-hidden="true" data-id="element-105" data-mp="2sdav2ofc34ro" />
          </div>

          <h2 className="text-3xl md:text-4xl font-display font-bold text-ink mb-8" data-id="element-106" data-mp="2sag7wp4xr5uk">
            🛡️ GARANTÍA 7 DÍAS — SIN PREGUNTAS
          </h2>

          <div className="space-y-4 text-lg text-muted mb-8" data-id="element-107" data-mp="xzt7j1exi7wn">
            <p data-id="element-108" data-mp="3sl6j1r5kf1s6">Abrís los tomos.</p>
            <p data-id="element-109" data-mp="3smhv0e95zfud">Los usás el primer domingo.</p>
            <p className="font-medium text-ink" data-id="element-110" data-mp="3sn9kd7c64hc7">
              Si en 7 días no es exactamente lo que esperabas, te devolvemos el 100% de tu
              dinero.
            </p>
            <p data-id="element-111" data-mp="3ivwom4n9170w">Sin formularios. Sin drama. Sin justificaciones.</p>
          </div>

          <div className="pt-8 border-t border-line" data-id="element-112" data-mp="3dxvazz8ldzwt">
            <p className="text-sm text-muted uppercase tracking-widest font-bold mb-2" data-id="element-113" data-mp="femv7tj8zdds">
              Nuestra tasa de devoluciones es menor al 1%.
            </p>
            <p className="text-pistachio-700 font-medium italic" data-id="element-114" data-mp="aglhlo4lc69p">
              No porque la garantía sea difícil de activar. Sino porque el sistema funciona.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}